import { NARRATIVE_VALUATOR_COMPANY_FRAGMENT } from '../../hooks/narrativeValuatorCompanyFragment';
import type { FragmentOf } from '@/utilities/gql';
import { gql } from '@/utilities/gql';
import { MONITORING_PANEL_COMPANY_OVERVIEW_FRAGMENT } from '@/components/MonitoringPanel';

export const NARRATIVE_SIDEBAR_COMPANY_FRAGMENT = gql(
  `
  fragment NarrativeSidebarCompanyFields on Company @_unmask {
    ...NarrativeValuatorCompanyFields,
    ...MonitoringPanelCompanyOverviewFields
  }
`,
  [
    NARRATIVE_VALUATOR_COMPANY_FRAGMENT,
    MONITORING_PANEL_COMPANY_OVERVIEW_FRAGMENT,
  ]
);

export type NarrativeSidebarCompany = FragmentOf<
  typeof NARRATIVE_SIDEBAR_COMPANY_FRAGMENT
>;
